import { LayoutSizeContext } from 'App';
import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import './WeatherSelectorTile.css';

const WeatherSelectorTile = ({
  onClick,
  label,
  value,
  icon,
  selected,
  buttonClassName,
  buttonStyle,
  iconStyle,
  labelStyle,
  valueStyle,
  ariaLabel,
  'aria-label': ariaLabelProp,
  ...buttonProps
}) => {
  const layout = useContext(LayoutSizeContext);
  const buttonAriaLabel = ariaLabel ?? ariaLabelProp;

  return (
    <Button
      {...buttonProps}
      aria-label={buttonAriaLabel}
      aria-pressed={typeof selected === 'boolean' ? selected : undefined}
      className={`weather-selector-tile rounded-pill p-3 w-100 h-100 d-flex flex-column align-content-center align-items-center justify-content-center ${selected ? 'weather-selector-tile-selected' : ''} ${buttonClassName}`}
      style={{
        backgroundColor: 'var(--color-primary)',
        color: 'var(--color-primary-foreground)',

        minHeight: 0,
        minWidth: 0,
        overflow: 'hidden',
        ...buttonStyle,
      }}
      type="button"
      onClick={onClick}
    >
      <div
        style={{
          fontSize: layout.baseFontSize,
          color: 'var(--color-primary-foreground)',
          maxWidth: '100%',
          ...labelStyle,
        }}
      >
        {label}
      </div>
      <div
        className="d-flex justify-content-center align-items-center "
        style={{
          width: 50 * layout.scaleMult,
          height: 50 * layout.scaleMult,
          flex: '0 0 auto',
          margin: '0 auto',
          ...iconStyle,
        }}
      >
        <IconContext.Provider
          value={{
            color: 'var(--color-primary-foreground)',
            size: '100%',
          }}
        >
          {icon}
        </IconContext.Provider>
      </div>
      <div
        style={{
          fontSize: layout.baseFontSize,
          color: 'var(--color-primary-foreground)',
          maxWidth: '100%',
          ...valueStyle,
        }}
      >
        {value}
      </div>
    </Button>
  );
};

export default WeatherSelectorTile;
